import type { ContentViewerSession, ViewerDocument, ViewerOpenContext, ViewerPresentation } from '@/content-viewer/store/schemas'

export function createViewerSession(args: { document: ViewerDocument; context: ViewerOpenContext; presentation?: ViewerPresentation }): ContentViewerSession {
  const { document, context, presentation } = args
  return {
    document,
    context,
    ...(presentation ? { presentation } : {}),
  }
}
